import React from "react";

interface FileViewerProps {
  fileUrl: string;
}

const FileViewer: React.FC<FileViewerProps> = ({ fileUrl }) => {
  const getFileType = (url: string): string => {
    const extension = url.split(".").pop()?.split("?")[0].toLowerCase();
    if (!extension) return "unsupported";
    if (["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension))
      return "image";
    if (["pdf"].includes(extension)) return "pdf";
    if (["mp4", "webm", "ogg"].includes(extension)) return "video";
    if (["mp3", "wav", "ogg"].includes(extension)) return "audio";
    return "unsupported";
  };

  const fileType = getFileType(fileUrl);

  if (fileType === "image") {
    return (
      <img
        src={fileUrl}
        alt="File"
        className="h-auto max-w-full shadow-md rounded-xl"
      />
    );
  }

  if (fileType === "pdf") {
    return (
      <iframe
        src={fileUrl}
        title="PDF Viewer"
        className="w-full h-screen shadow-md rounded-xl"
      ></iframe>
    );
  }

  if (fileType === "video") {
    return (
      <video controls className="w-full shadow-md rounded-xl">
        <source src={fileUrl} type={`video/${fileUrl.split(".").pop()}`} />
        Your browser does not support the video tag.
      </video>
    );
  }

  if (fileType === "audio") {
    return (
      <audio controls className="w-full shadow-md rounded-xl">
        <source src={fileUrl} type={`audio/${fileUrl.split(".").pop()}`} />
        Your browser does not support the audio tag.
      </audio>
    );
  }

  return <p className="text-red-500">Unsupported file type.</p>;
};

export default FileViewer;
